import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n';
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import Axios from 'axios';

Vue.config.productionTip = false
Vue.prototype.$http = Axios;
Vue.prototype.$user=new Object;
Vue.prototype.$business=new Object;
Vue.prototype.$userkey='';
Vue.prototype.$isloggedin=false;







Vue.prototype.$apidomain="https://api.juzzap.com/api/";
Vue.prototype.$domain="https://juzzap.com/0001/";

let user = JSON.parse(localStorage.getItem('user')||'{}');

let business = JSON.parse(localStorage.getItem('business')||'{}');


Vue.prototype.$http.defaults.headers.common['Content-Type']='application/json';
Vue.prototype.$http.defaults.headers.common['X-Requested-With']='XMLHttpRequest';
Vue.prototype.$http.defaults.headers.common['Access-Control-Allow-Origin']='*';
Vue.prototype.$http.defaults.headers.common['Access-Control-Allow-Methods']='GET,POST,PATCH,PUT,DELETE,OPTIONS';

//console.log("User "+Object.keys(user).length);

if(Object.keys(user).length!=0)
{
 Vue.prototype.$http.defaults.headers.common['Authorization']='Bearer '+user.token;
 Vue.prototype.$user=user;

 Vue.prototype.$business=business;

 Vue.prototype.$isloggedin=true;
 localStorage.setItem('isLoggedin','true');

}else{
  Vue.prototype.$isloggedin=false;
  localStorage.setItem('isLoggedin','false');
  // if(localStorage.getItem('userKey')!='')
  // {
  //   Vue.prototype.$userkey=localStorage.getItem('userKey');
  // }


}


new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
